import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=1be850d7&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/footer.css?vue&type=style&index=0&id=1be850d7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be850d7",
  null
  
)

export default component.exports